import React from "react";

const TeamCard = ({ name, role, image }) => {
  return (
    <div className="team-card">
      <div className="team-card__image-container">
        <img src={image} alt={name} className="team-card__image" />
        <div className="team-card__role-overlay">
          <span className="team-card__role">{role}</span>
        </div>
      </div>
      <div className="team-card__info">
        <h3 className="team-card__name">{name}</h3>
      </div>
    </div>
  );
};

export default TeamCard;
